import type { Question } from '../models/Question';
import type { Group } from '../models/Group';
import type { FormService } from './formService';

export interface IFieldInfoService {
  getAlert(question: Question, group: Group): string;
}

export class FieldInfoService implements IFieldInfoService {
  constructor(protected formService: FormService) {}

  public getAlert(_question: Question, _group: Group): string {
    return '';
  }
}
